// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"628":"12382e49","1167":"8cc1cc04","3258":"9712e80b","4723":"cc6198f7","4794":"9e0758db","6020":"b80f0050","6810":"9e0758db"}[chunkId] + ".chunk.css";
};